import { observable, action } from "mobx";
import axios from "axios";

class Auth {
  @observable formData = {
    username: "",
    password: "",
    confirmPassword: "",
    secretWord: ""
  };

  @observable errorText = "";

  @observable signIn = true;

  @observable token = "";

  @action changeSignType(singIn) {
    this.signIn = singIn;
  }

  @action inputChange(e) {
    this.formData[e.target.name] = e.target.value;
  }

  @action login(cb) {
    const { username, password } = this.formData;

    axios
      .post("/api/auth/login", {
        username,
        password
      })
      .then(({ data }) => {
        const { ok } = data;

        if (ok) {
          const { token } = data;

          localStorage.setItem("authToken", token);
          cb(false, token);
        } else {
          const { errorText } = data;

          this.errorText = errorText;
          cb(errorText);
        }
      })
      .catch(error => {
        cb(error);
      });
  }

  @action register(cb) {
    const { username, password, confirmPassword, secretWord } = this.formData;

    axios
      .post("/api/auth/register", {
        username,
        password,
        confirmPassword,
        secretWord
      })
      .then(({ data }) => {
        const { ok } = data;

        if (ok) {
          const { token } = data;

          localStorage.setItem("authToken", token);
          cb(false, token);
        } else {
          const { errorText } = data;

          this.errorText = errorText;
          cb(errorText);
        }
      })
      .catch(error => {
        cb(error);
      });
  }

  @action logout(cb) {
    axios
      .get("/api/auth/logout")
      .then(() => {
        localStorage.setItem("authToken", "");
        cb(false);
      })
      .catch(error => {
        cb(error);
      });
  }
}

export default new Auth();



// WEBPACK FOOTER //
// ./src/stores/auth.js